import { useT } from "react-polyglot-hooks"
import { useRouter } from "next/router"
import styled from "styled-components"
import { Container } from "components/styled/Grid"
import Typography from "components/styled/Typography"
import LazyLoad from "react-lazyload";
import dynamic from "next/dynamic";
import {useContext} from "react";
import LoadingPlaceholder from "../../../../components/LoadingPlaceholder";
import {ModelContext} from "../../ModelContext";

const Offers = dynamic(() => import("components/landing/OffersWrapper"), { loading: () => <LoadingPlaceholder /> })

const FullRow = styled.div`
  width: 100vw;
  position: relative;
  margin-left: -50vw;
  left: 50%;
  padding: 50px;
  background: white;
`

const Title = styled(Typography)`
  margin: 16px 0;
`

export default function NoCars() {
  const { offers, brand, model } = useContext(ModelContext)
  const t = useT()
  const router = useRouter()

  // Detectar si estamos en una página de compra flexible
  const isFlexible = router.pathname.includes('compra-flexible')
  const sellingStatus = isFlexible ? "flexible" : "new"

  return (
    <Container top={25} bottom={50}>
      <FullRow>
        <Container>
          <Title variant="title3" weight="medium" center>
            {t(`model.cars.${sellingStatus}.no-cars`, { brand: brand.name, model: model.name })}
          </Title>
          <LazyLoad height={500} offset={200} once>
            <Offers cars={offers} page="model" />
          </LazyLoad>
        </Container>
      </FullRow>
    </Container>
  )
}
